import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { appRouteAnimations } from './route-animations';
import { UserService } from './core/services/user.service';
import { filter } from 'rxjs/operators';
import { UrlService } from './core/services/url.service';
import { DataLayerService } from './core/services/data-layer.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  animations: [appRouteAnimations]
})
export class AppComponent {

  previousUrl;
  currentUrl;
  model: any = {};
  constructor(
    private userService: UserService,
    private router: Router,
    private urlService: UrlService,
    private _dataLayerService: DataLayerService) {
    this.userService.setUser();

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this._dataLayerService.logPageView(event.url);
      }
    });
  }

  ngOnInit(): void {
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.previousUrl = this.currentUrl;
      this.currentUrl = event.url;
      this.urlService.setPreviousUrl(this.previousUrl);

      console.log('Previous URL:', this.previousUrl);
    });
  }

  prepareRoute(outlet: RouterOutlet) {

    return outlet && outlet.activatedRouteData && outlet.activatedRouteData.animation;
  }
}
